import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';
import { Link } from 'react-router-dom';

export const agentSelectedDispositionAtom = atom({
    key: RecoilAtomKey.agentSelectedDispositionKey,
    default: [],
});

export const agentDatewiseSelectedDispositionAtom = atom({
    key: RecoilAtomKey.agentDatewiseSelectedDispositionKey,
    default: [],
});